import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';

const EdenAutoPromoMobile = () => {
  return (
    <Card
      sx={{
        backgroundColor: 'rgba(255,255,255,0.05)',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(212, 175, 55, 0.3)',
        borderRadius: '16px',
        overflow: 'hidden',
        mx: 'auto',
        maxWidth: '340px',
        width: '90%'
      }}
    >
      {/* Image Header */}
      <Box sx={{ position: 'relative', height: '200px', overflow: 'hidden' }}>
        <Box
          component="img"
          src="https://www.lamontagne.fr/static/bloc/pagesStatiques/publi_redac/images/22-05-edenauto-toyota-logo-1.jpg"
          alt="Eden Auto Montauban"
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center'
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            top: 12,
            right: 12,
            backgroundColor: '#D4AF37',
            color: '#000',
            px: 2,
            py: 0.75,
            borderRadius: '8px',
            fontSize: '0.875rem',
            fontWeight: 700,
            textTransform: 'uppercase',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
          }}
        >
          -10%
        </Box>
      </Box>

      {/* Content */}
      <CardContent sx={{ p: 3 }}>
        <Typography
          variant="h5"
          sx={{
            color: '#D4AF37',
            fontWeight: 700,
            fontSize: '1.5rem',
            mb: 1,
            textAlign: 'center'
          }}
        >
          Eden Auto Montauban
        </Typography>

        <Typography
          sx={{
            color: '#fff',
            fontSize: '0.95rem',
            mb: 2.5,
            textAlign: 'center',
            lineHeight: 1.5
          }}
        >
          Tarifs préférentiels sur les modèles Toyota
        </Typography>

        <Box
          sx={{
            backgroundColor: 'rgba(212, 175, 55, 0.1)',
            border: '1px solid rgba(212, 175, 55, 0.3)',
            borderRadius: '12px',
            p: 2,
            mb: 2.5
          }}
        >
          <Typography
            sx={{
              color: '#fff',
              fontSize: '0.9rem',
              lineHeight: 1.6,
              mb: 2,
              textAlign: 'center'
            }}
          >
            <strong style={{ color: '#D4AF37' }}>10% de remise</strong> sur les modèles
          </Typography>

          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: 1.5
            }}
          >
            {['AYGO X', 'YARIS CROSS', 'COROLLA TOURING', 'C-HR'].map((model, index) => (
              <Box
                key={index}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: 'rgba(212, 175, 55, 0.15)',
                  color: '#D4AF37',
                  fontSize: '0.85rem',
                  fontWeight: 600,
                  py: 1,
                  px: 1.5,
                  borderRadius: '8px',
                  textAlign: 'center'
                }}
              >
                {model}
              </Box>
            ))}
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 2,
            pt: 1
          }}
        >
          <Box
            component="img"
            src="https://www.guide-auto.com/wp-content/uploads/2022/12/toyota-logo.png"
            alt="Toyota"
            sx={{ height: '35px', width: 'auto' }}
          />
          <Typography
            sx={{
              color: '#999',
              fontSize: '0.8rem'
            }}
          >
            Concessionnaire Toyota
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default EdenAutoPromoMobile;
